// Vendored from quill-languagetool v1.0.7 — adapted for Quill v2
// Key change: extend Inline instead of Bold to avoid optimize() conflicts with Quill v2

import { MatchesEntity } from "./types";

/**
 * Quill editor blot that represents a suggestion.
 * This is added to the text to enable the suggestion to be selected and inserted.
 *
 * @param Quill Quill static instance
 * @returns Blot class that can be registered on the Quill instance
 */
export default function createSuggestionBlotForQuillInstance(Quill: any) {
  const Inline = Quill.import("blots/inline");

  class SuggestionBlot extends Inline {
    static blotName = "ltmatch";
    static tagName = "quill-lt-match";

    static create(match?: MatchesEntity) {
      const node: HTMLElement = super.create();
      if (match) {
        node.setAttribute("data-offset", match.offset.toString());
        node.setAttribute("data-length", match.length.toString());
        node.setAttribute("data-rule-id", match.rule.id);
      }
      return node;
    }

    // In Quill v2, optimize() must not be empty — it must call super.optimize()
    // or the editor's optimization cycle breaks.
    optimize(context: any) {
      super.optimize(context);
    }
  }

  return SuggestionBlot;
}
